import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-e-ticketing',
  templateUrl: './e-ticketing.component.html',
  styleUrls: ['./e-ticketing.component.scss']
})
export class ETicketingComponent implements OnInit {

  bearer;
  feedback = [];
  topicId;

  constructor(
    private svc: StoreService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.getFeedbackList();
  }

  getFeedbackList() {
      this.svc.getFeedbackTopic(this.bearer).subscribe(res => {

        this.feedback = res['data'];
        console.log(this.feedback);

      })
    }

    goFeedbackListPage(id){
     //this.router.navigate(['/property-detail',id]);
     let navigationExtras: NavigationExtras = {
       state: {
         topicId: this.topicId
       }
     };
     this.router.navigate(['/dashboard/e-ticketing-list',id], navigationExtras);
   }

}
